module.exports = fox._r("images/splash-bg.jpg", __webpack_public_path__ + "images/splash-bg.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/splash-bg.jpg
// module id = 504
// module chunks = 4